import React, { useState, useEffect } from 'react';
import {
  FaEnvelopeOpen,
  FaUser,
  FaCalendarTimes,
  FaMap,
  FaPhone,
  FaLock,
} from 'react-icons/fa'
const url = 'https://randomuser.me/api/';
const defaultImage = 'https://randomuser.me/api/portraits/men/75.jpg';
function App() 
{
  const [ loading, setLoading ] = useState(true);
   const [ person, setPerson ] = useState(null);
   const [ title, setTitle ] = useState('name');
   const [ value, setValue ] = useState('random person');
   const handleValue = (e)=>
   {
     if(e.target.classList.contains('icon'))
     {
       const prop = e.target.dataset.label;
       setTitle(prop);
       setValue(person[prop]);
     }
   }

   const getPerson = async ()=>
   {
     setLoading(true);
     const response = await fetch(url);
     const data = await response.json();
     const { results } = data;
     const person =  results[0];
     const { phone, email, picture, login, name, dob, location } = person;
     const { large:image } = picture;
     const {password} = login;
     const { first, last } = name;
     const { age } = dob;
     const { street, city, state, country, postcode } = location;
     const { number, name : address } = street;
     console.log(location);
     const user = { image, phone, email, password, age, name : `${first} ${last}`, address : `#${number}, ${address}, ${city}, ${state}, ${country}, ${postcode}.` };
     setPerson(user);
     setTitle('name');
     setValue(user.name);
     setLoading(false);
   }

   useEffect(()=>
   {
     getPerson();
   }, [])

  return (
    <>
    <h1>Generate Random User</h1>
    <main>
      <div className = "block bcg-block"></div>
      <div className = "block">
          <div className = "container">
            <img src={(person && person.image) || defaultImage} alt="" className = 'user-img'/>
            <p className = 'user-title'>My {title} is </p>
            <p className = 'user-value'>{value}</p>
            <div className = "values-list">
              <button className = "icon" data-label = 'name' onMouseOver = {handleValue}><FaUser/></button>
              <button className = "icon" data-label = 'email' onMouseOver = {handleValue}><FaEnvelopeOpen/></button>
              <button className = "icon" data-label = 'age' onMouseOver = {handleValue}><FaCalendarTimes/></button>
              <button className = "icon" data-label = 'address' onMouseOver = {handleValue}><FaMap/></button>
              <button className = "icon" data-label = 'phone' onMouseOver = {handleValue}><FaPhone/></button>
              <button className = "icon" data-label = 'password' onMouseOver = {handleValue}><FaLock/></button>
            </div>
            <button className="btn" type = 'button' onClick={getPerson}>
              { loading ? 'Loading .....' : 'Random User' }
            </button>
          </div>
        </div>
    </main>
    </>);
}

export default App;
